export const EMPTY_OBJECT = {};

export const EMPTY_ARRAY = [];

export const DEFAULT_THRESHOLD = undefined;

export const INITIAL_LESS_NEGATIVE_THRESHOLD = undefined;
export const INITIAL_MORE_NEGATIVE_THRESHOLD = undefined;

export default {
	EMPTY_OBJECT,
	EMPTY_ARRAY,
	DEFAULT_THRESHOLD,

	INITIAL_LESS_NEGATIVE_THRESHOLD,
	INITIAL_MORE_NEGATIVE_THRESHOLD,
};
